import { LazyLoader } from '@bp/ui-components';
import classNames from 'classnames';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import styles from './App.module.css';
import { AppHeader } from './components/AppHeader/AppHeader';
import { Breadcrumb } from './components/Breadcrumb/Breadcrumb';
import { Sidebar } from './components/Sidebar/Sidebar';

export const DataLoader = () => {
  const mainClasses = classNames(styles.content, 'has-scrollbar');
  return (
    <>
      <Sidebar />
      <div className={mainClasses} id='content' data-cy='layoutContentColumn'>
        <AppHeader />
        <main className={styles.container}>
          <Breadcrumb />
          <Suspense fallback={<LazyLoader transparent forceHeight='50vh' fullWidth size='xxl' />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </>
  );
};
